import React, { useState, useImperativeHandle, forwardRef } from "react";
import siliconLab from "../../../assets/images/Footer.png";
import { useHistory } from "react-router-dom";

import "./style.scss";


const ActionBar = forwardRef((props, ref) => {
  const [, setFilter] = useState(props.filter);
  const history = useHistory();


  useImperativeHandle(
    ref,
    () => ({
      closeFilter() {
        setFilter(false)
      }
    }),
    []
  )


  const handleRedirect = () => {
    history.push("/");
  };
    
  return (
    <div className="action-bar-wrapper">
      <div className="row w-100">
      <div onClick={handleRedirect} className="ml-3 cursor-pointer">
          <div className="silicon-lab-anchor">
            <img src={siliconLab} className="silicon-lab-logo" alt="Hajj app LOGO" draggable={false} />
          </div>
      </div>
        <div className="actions-wrap">
        {/* <div> */}
          {/* <div className="cursor-pointer filter" id="filter" onClick={()=>setFilter(!filter)}>
      <img className="action-icon" src={filterIcon} />
      <p className="action-text">FILTER</p>
      </div>
      {filter && <div className="text-white filter-modal" id="filterModal">
        <div className="filter-head">
          <span className="filter-heading">Filters</span>
          <span className="cursor-pointer filter-reset" onClick={handleReset}>Reset</span>
        </div>
        <div className="filter-body">
          <div className="toggler cursor-pointer" onClick={()=>{setEcoSystem(!ecoSystem);setProtocol(false)}}>
            <span>ECOSYSTEM</span>
            <img src={ecoSystem ? minusIcon : plusIcon}/>
          </div> */}
        {/* <Collapse isOpen={ecoSystem}>
        {ecosystems.map((v,i)=>{
          return(
          <div className="list-item" key={i}>
            <div className="item-sub">
            <span>{v.title}</span>
            <div className="item-checkbox">
            <input name={v.name} onChange={(e)=>handleCheckChange(v.name,e.target.checked)} type="checkbox" className="check-boxes"/>
            <img src={selected[v.name]?checkedIcon:uncheckedIcon}/>
            </div>
            </div>
            </div>

          )
        })}
      </Collapse> */}
      {/* <div className="toggler cursor-pointer"  onClick={()=>{setProtocol(!protocol);setEcoSystem(false)}}>
            <span>PROTOCOLS</span>
            <img src={protocol ? minusIcon : plusIcon}/>
          </div>
        <Collapse isOpen={protocol}>
        {protocols.map((v,i)=>{
          return(
          <div className="list-item" key={i}>
            <div>
            <div className="item-sub">
            <span>{v.title}</span>
            <div className="item-checkbox">
            <input name={v.name} onChange={(e)=>handleCheckChange(v.name,e.target.checked)} type="checkbox" className="check-boxes"/>
            <img src={selected[v.name]?checkedIcon:uncheckedIcon}/>
            </div>
           
            </div>
            </div>
            </div>

          )
        })}
      </Collapse>
      <center><button className="show-results mt-4" onClick={()=>props.openFilterResults(selected)}>SHOW RESULTS</button></center>
        </div>
        
      </div>}
      </div> */}
      {/* <center className="share-wrap cursor-pointer" id="sharemain" style={{ marginTop:"-20px"}}> */}
        {/* <div id="sharewrap" className="hidden-wrap"> */}
        {/* <a href="mailto:?body=https://solutions.silabs.com/" target="_blank">
      <img className="action-icon" src={shareEmailIcon}/>
      </a><br/> */}

      {/* <a href="https://twitter.com/intent/tweet?text=silabs.com&url=https://solutions.silabs.com/" target="_blank">
      <img className="action-icon" src={shareTwitterIcon}/>
      </a><br/> */}

      {/* <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://solutions.silabs.com/" target="_blank">
      <img className="action-icon" src={shareLinkedIcon}/>
      </a><br/> */}
      {/* </div> */}
      {/* <div id="shareToggler" className="share-toggler" onClick={handleShowShareBar}> */}
      {/* <img className="action-icon" src={shareIcon}/> */}
      {/* <p className="action-text">SHARE</p> */}
      {/* </div> */}
      {/* </center> */}

      {/* <center className="ml-3 cursor-pointer" onClick={() => setShowTutorial(true)}> */}
      {/* <img className="action-icon" src={helpIcon} /> */}
      {/* <p className="action-text">HELP</p> */}
      {/* </center> */}
        </div>
      </div>
      </div>
    // </div>
  );
})

export default ActionBar;
